import { errorMessage } from './error';
import { Message, MessageType } from './Message';
import { IMessageCallbacks, ThreadChannel } from './ThreadChannel';

export class ConsumerChannel extends ThreadChannel {
  protected messageEvents: IMessageCallbacks = {};

  public expose(instance: any) {
    if (!instance.type) {
      throw new Error(
        errorMessage('wrong exposed API instance, "type" property is required'),
      );
    }

    this.queue.push(new Message(MessageType.ExposeAPI, instance));
    this.flush();
  }
}
